'use client';

import { vars } from '@/theme/vars.css';
import { FormControl, Select, SelectChangeEvent } from '@mui/material';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import Grid from '../ui/Grid';
import Txt from '../ui/Txt';
import { DEFAULT_ORDER, useEntryIndex } from './useEntryIndex';

const sortFilters: { [key: string]: string } = {
  Oldest: 'postDate ASC',
};

export default function EntryIndexSorters() {
  const [value, setValue] = useState<string>(DEFAULT_ORDER);
  const t = useTranslations('entryIndex');
  const setOrder = useEntryIndex((s) => s.setOrder);
  const sorterId = 'sorter';
  const sorterLabelId = 'sorter-label';

  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value);
    setOrder(event.target.value);
  };

  return (
    <Grid.Col md={3}>
      <FormControl fullWidth>
        <Txt id={sorterLabelId} as="label" htmlFor={sorterId} variant="body" autoMargin>
          {t('sortBy')}
        </Txt>
        <Select
          native
          id={sorterId}
          value={value}
          variant="filled"
          onChange={handleChange}
          disableUnderline
          style={{
            borderWidth: '1px',
            borderColor: vars.palette.colorSets.full.contrastText,
            borderStyle: 'solid',
          }}
          sx={{
            '& select': {
              paddingTop: vars.spacing['3xs'],
              paddingBottom: vars.spacing['3xs'],
            },
            '& select:focus-visible': {
              outline: '2px solid currentColor',
              outlineOffset: '2px',
            },
          }}>
          <option value={DEFAULT_ORDER}>{t('sortDefault')}</option>
          {Object.entries(sortFilters).map(([key, label]) => {
            return (
              <option key={key} value={label}>
                {key}
              </option>
            );
          })}
        </Select>
      </FormControl>
    </Grid.Col>
  );
}
